import angular from 'angular'
import previewTemplateCtrl from './previewTemplateCtrl'

import {
    templateSetUp
} from 'redevConfig'


const add = (templateSetUp && templateSetUp.add) || ''
const list = (templateSetUp && templateSetUp.list) || ''

const templateSetUpCtrl = list ? require(`redevelopment/system/templateSetUp/${list.controllerName}`) : require('./templateSetUpCtrl')
const addTemplateSetUpCtrl = add ? require(`redevelopment/system/templateSetUp/${add.controllerName}`) : require('./addTemplateSetUpCtrl')

const listPage = list ? require(`redevelopment/system/templateSetUp/${list.templateName}`) : require('./view/templateSetUp.html')
const addPage = add ? require(`redevelopment/system/templateSetUp/${add.templateName}`) : require('./view/addTemplateSetUp.html')

export default angular
    .module('system.settingcenter.templateSetUp', []).config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('system.settingcenter.templateSetUp', {
                url: '/templateSetUp',
                abstract: true,
                template: '<div ui-view></div>',
                default: 'system.settingcenter.templateSetUp.list',
                title: '模版设置',
            })
            .state('system.settingcenter.templateSetUp.list', {
                url: '/list',
                template: listPage,
                controller: 'templateSetUpCtrl',
            })
            .state('system.settingcenter.templateSetUp.add', {
                url: '/add',
                template: addPage,
                controller: 'addTemplateSetUpCtrl',
                title: '新增模版',
            })
            .state('system.settingcenter.templateSetUp.edit', {
                url: '/edit/:templateId',
                template: addPage,
                controller: 'addTemplateSetUpCtrl',
                title: '编辑模版',
            })
    }])
    .controller('templateSetUpCtrl', templateSetUpCtrl.default)
    .controller('addTemplateSetUpCtrl', addTemplateSetUpCtrl.default)
    .controller('previewTemplateCtrl', previewTemplateCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/templateSetUp/index.js